/* ============================================================================
   PADRE SANTO — Bundle Builder · un solo bloque para toda la selección.
   Subir como asset del tema. Arranca todos los [data-psbb-root] de la página.

   Un solo bloque pinta:
     · el tab bar (Individual / 2 Pack / 3 Pack / 5 Pack), con el mismo diseño
       que el de Instant en la PDP, para no depender de sus tabs;
     · el panel de 1 pant (color / talla / largo + carrito), que además mueve la
       galería de Instant igual que lo hacía su variant picker nativo;
     · los paneles de paquete (grid de huecos + popup de selección).

   También sigue arrancando los bloques viejos [data-psbb] (uno por tier) para
   que la página no se rompa mientras se retiran de Instant.
   ============================================================================ */
(function(){
  if (window.__psbbCargado) return;
  window.__psbbCargado = true;

  /* Última combinación que la persona eligió. Vive en el scope del asset, así que
     se comparte entre el panel de 1 pant y los paquetes de la misma página. */
  var ultima = null;

  /* Va acá arriba y no dentro de initApp a propósito: los paneles se montan antes de
     que se ejecute el cuerpo de initApp, así que un `var` declarado más abajo todavía
     valdría undefined al pintar el primero. */
  var MESES = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sept','Oct','Nov','Dic'];

  function esc(t){
    return String(t == null ? '' : t)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function initApp(root){
    if (!root || root.dataset.psbbReady) return;
    var nodoDatos = root.querySelector('[data-psbb-data]');
    if (!nodoDatos) return;
    root.dataset.psbbReady = '1';

    var D = JSON.parse(nodoDatos.textContent);

    // Bloque viejo: no trae tiers, así que lo tratamos como un tier suelto sin tabs.
    var esLegacy = !root.hasAttribute('data-psbb-root');
    var tiers = (D.tiers && D.tiers.length)
      ? D.tiers
      : [{ size: D.packSize, pct: D.discountPct, cols: D.cols || 4 }];

    var money = function(cents){
      var v = cents / 100;
      var dec = (Math.round(v * 100) % 100 === 0) ? 0 : 2;   // sólo muestra centavos si los hay
      return '$' + new Intl.NumberFormat('es-MX',
        {minimumFractionDigits:dec, maximumFractionDigits:dec}).format(v);
    };

    // exactMath=false: redondea a peso entero por unidad (mockup, $1,039).
    // exactMath=true : matemática exacta de Shopify, que es lo que cobra el carrito.
    function unitCents(pct){
      return D.exactMath
        ? D.basePrice * (100 - pct) / 100
        : Math.round(D.basePrice * (100 - pct) / 100 / 100) * 100;
    }

    /* ── Stock ──────────────────────────────────────────────────────────── */
    function hayStock(color, size, inseam){
      var k = color + '|' + size + '|' + inseam;
      return !!D.variants[k] && !D.agotadas[k];
    }
    function tallaConStock(color, size){
      for (var i = 0; i < D.inseams.length; i++) {
        if (hayStock(color, size, D.inseams[i])) return true;
      }
      return false;
    }
    function colorPorNombre(n){
      for (var i = 0; i < D.colors.length; i++) { if (D.colors[i].name === n) return D.colors[i]; }
      return D.colors[0];
    }

    /* ── Montaje ────────────────────────────────────────────────────────── */
    var paneles = [];        // { tier, el, tipo, pack? }
    var packs = [];          // sólo los paneles de paquete, para repintarlos juntos
    var activo = 0;
    /* Selección compartida por TODOS los tiers: un único array de pantalones.
       Cada panel muestra los primeros `size`, así que pasar de 5 Pack a 3 Pack
       conserva los tres primeros, y volver a 5 los recupera con dos huecos.
       Se declara acá arriba porque los paneles se montan antes que el resto del
       cuerpo de initApp: un `var` más abajo se ejecutaría después y lo borraría. */
    var seleccion = [];
    var hostTabs    = root.querySelector('[data-psbb-tabs]');
    var hostPaneles = root.querySelector('[data-psbb-panels]');

    if (esLegacy) {
      // El bloque viejo ES el .psbb: le pintamos el paquete dentro y ya.
      root.innerHTML = markupPack(tiers[0]);
      paneles.push(nuevoPack(tiers[0], root, root));
    } else {
      tiers.forEach(function(tier, i){
        var panel = document.createElement('div');
        panel.className = 'psbb-panel';
        panel.setAttribute('role','tabpanel');
        if (i !== 0) panel.hidden = true;
        hostPaneles.appendChild(panel);

        if (Number(tier.size) <= 1) {
          paneles.push(nuevoUno(tier, panel));
        } else {
          var caja = document.createElement('div');
          caja.className = 'psbb';
          caja.style.setProperty('--psbb-cols', tier.cols || 4);
          caja.style.setProperty('--psbb-cols-m', tier.colsM || D.colsMovil || 3);
          caja.innerHTML = markupPack(tier);
          panel.appendChild(caja);
          paneles.push(nuevoPack(tier, panel, caja));
        }
      });
      if (tiers.length > 1) montarTabs();
      else if (hostTabs) hostTabs.style.display = 'none';
    }

    /* ── Tab bar ────────────────────────────────────────────────────────── */
    function montarTabs(){
      if (!hostTabs) return;
      hostTabs.setAttribute('role','tablist');
      tiers.forEach(function(tier, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'psbb-tab';
        b.setAttribute('role','tab');
        b.setAttribute('aria-selected', String(i === 0));

        var badge = tier.badge
          ? '<span class="psbb-tab__badgeWrap"><span class="psbb-tab__badge"' +
              (tier.badgeBg ? ' style="--psbb-badge-bg:' + esc(tier.badgeBg) + '"' : '') + '>' +
              esc(tier.badge) + '</span></span>'
          : '';
        var precio = money(unitCents(Number(tier.pct) || 0));
        b.innerHTML = badge +
          '<span class="psbb-tab__label">' + esc(tier.label) + '</span>' +
          '<span class="psbb-tab__price">' +
            '<span class="psbb-tab__amount"' +
              (tier.priceColor ? ' style="--psbb-price-color:' + esc(tier.priceColor) + '"' : '') + '>' +
              esc(precio) + '</span>' +
            '<span>/</span><span>' + esc(D.tabUnidad || 'pant') + '</span>' +
          '</span>';

        b.addEventListener('click', function(){ irATab(i); });
        hostTabs.appendChild(b);
      });
    }

    function irATab(i){
      if (i === activo) return;
      activo = i;
      if (hostTabs) {
        [].forEach.call(hostTabs.children, function(b, n){
          b.setAttribute('aria-selected', String(n === i));
        });
      }
      paneles.forEach(function(p, n){ p.el.hidden = (n !== i); });
      // El panel de 1 pant manda su selección a Instant en cuanto se muestra,
      // para que la galería no se quede en el color del paquete anterior.
      if (paneles[i] && paneles[i].alMostrar) paneles[i].alMostrar();
    }

    /* ── Panel de paquete ───────────────────────────────────────────────── */
    function markupPack(tier){
      return '' +
        '<div class="psbb__head">' +
          '<span class="psbb__headLeft">' +
            '<strong>' + esc(D.textoPaquete || 'TU PAQUETE') + '</strong>' +
            '<span class="psbb__hint">' + esc(D.textoHint || '| click para personalizar') + '</span>' +
            (D.arrowUrl ? '<img class="psbb__squiggle" src="' + esc(D.arrowUrl) + '" alt="" aria-hidden="true" loading="lazy">' : '') +
          '</span>' +
          '<span class="psbb__count" data-psbb-count></span>' +
        '</div>' +
        '<div class="psbb__grid" data-psbb-grid></div>' +
        '<div class="psbb__pricing">' +
          '<span class="psbb__total" data-psbb-total></span>' +
          '<s class="psbb__compare" data-psbb-compare></s>' +
          '<span class="psbb__save" data-psbb-save></span>' +
          '<span class="psbb__unit" data-psbb-unit></span>' +
        '</div>' +
        '<button type="button" class="psbb__cta" data-psbb-cta disabled>' + esc(D.ctaPack || 'Agregar al carrito') + '</button>' +
        markupPie();
    }

    /* ── Pie: fila de confianza + línea de tiempo ───────────────────────── */
    function markupPie(){ return markupTrust() + markupTimeline(); }

    function markupTrust(){
      var items = D.trust || [];
      if (!items.length) return '';
      var h = '<div class="psbb__trust">';
      items.forEach(function(it){
        h += '<span class="psbb__trustItem">' +
               (it.icono ? '<img class="psbb__trustIcon" src="' + esc(it.icono) +
                           '" alt="" aria-hidden="true" loading="lazy">' : '') +
               esc(it.texto) +
             '</span>';
      });
      return h + '</div>';
    }

    /* Días hábiles: se saltan sábados y domingos. No contempla feriados; si algún día
       hace falta, lo más simple es una lista de fechas en la config y descartarlas acá. */
    function sumarHabiles(fecha, dias){
      var d = new Date(fecha.getTime());
      var n = 0;
      while (n < dias) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) n++;
      }
      return d;
    }

    /* Corre la fecha al siguiente día hábil si cayó en finde; si ya es hábil, la deja igual. */
    function proximoHabil(fecha){
      var d = new Date(fecha.getTime());
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      return d;
    }

    function fechaCorta(d){ return d.getDate() + ' ' + MESES[d.getMonth()]; }

    /* Cada paso suma días hábiles sobre el anterior: compra hoy (0), envío el mismo
       día (0) y entrega +4 desde el envío. El primer paso es la compra y lleva la fecha
       real de hoy, aunque sea finde; los que siguen son operación nuestra, así que
       arrancan en día hábil. */
    function markupTimeline(){
      var pasos = D.pasos || [];
      if (!pasos.length) return '';
      var fecha = new Date();
      var h = '<div class="psbb__tl">';
      pasos.forEach(function(paso, i){
        var suma = Number(paso.dias) || 0;
        if (i) fecha = proximoHabil(fecha);
        if (suma) fecha = sumarHabiles(fecha, suma);
        if (i) h += '<span class="psbb__tlLine" aria-hidden="true"></span>';
        h += '<span class="psbb__tlStep">' +
               (paso.icono ? '<img class="psbb__tlIcon" src="' + esc(paso.icono) +
                             '" alt="" aria-hidden="true" loading="lazy">' : '') +
               '<span class="psbb__tlTitle">' + esc(paso.titulo) + '</span>' +
               '<span class="psbb__tlDate">' + esc(fechaCorta(fecha)) + '</span>' +
             '</span>';
      });
      return h + '</div>';
    }

    function nuevoPack(tier, el, caja){
      var pack = {
        tier: tier, el: el, tipo: 'pack',
        size: Number(tier.size),
        grid: caja.querySelector('[data-psbb-grid]'),
        cta:  caja.querySelector('[data-psbb-cta]'),
        caja: caja,
        botones: []
      };
      // Los nodos del bloque de precio se buscan una vez, no en cada repintado.
      var nTotal   = caja.querySelector('[data-psbb-total]');
      var nCompare = caja.querySelector('[data-psbb-compare]');
      var nSave    = caja.querySelector('[data-psbb-save]');
      var nUnit    = caja.querySelector('[data-psbb-unit]');
      var nCount   = caja.querySelector('[data-psbb-count]');

      pack.primerHueco = function(){
        for (var i = 0; i < pack.size; i++) { if (!seleccion[i]) return i; }
        return 0;
      };
      pack.llenos = function(){
        var n = 0;
        for (var i = 0; i < pack.size; i++) { if (seleccion[i]) n++; }
        return n;
      };

      /* El grid se construye UNA vez y después sólo se actualiza en el sitio. Antes
         se hacía innerHTML='' en cada cambio, lo que recreaba los <img> y volvía a
         pedirlos al CDN, con parpadeo incluido. */
      function construirGrid(){
        var frag = document.createDocumentFragment();
        for (var i = 0; i < pack.size; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'psbb__slot psbb__slot--empty';
          b.setAttribute('data-i', i);
          b.innerHTML =
            '<img class="psbb__thumb" alt="" loading="lazy">' +
            '<span class="psbb__slotName"></span>' +
            '<span class="psbb__slotMeta"></span>' +
            '<span class="psbb__plus">+</span>';
          pack.botones.push(b);
          frag.appendChild(b);
        }
        pack.grid.appendChild(frag);
        /* Un solo listener delegado en el grid en vez de uno por slot.
           Slot lleno -> edita ese mismo. Slot vacío -> siempre cae en el primer
           hueco libre, así el paquete se llena 1, 2, 3... sin importar dónde se
           hizo click. */
        pack.grid.addEventListener('click', function(e){
          var b = e.target.closest('[data-i]');
          if (!b) return;
          var i = Number(b.getAttribute('data-i'));
          openModal(pack, seleccion[i] ? i : pack.primerHueco());
        });
      }

      pack.render = function(){
        if (!pack.botones.length) construirGrid();
        for (var i = 0; i < pack.size; i++) {
          var b = pack.botones[i], sl = seleccion[i];
          var img = b.firstChild, nom = img.nextSibling, met = nom.nextSibling;
          if (sl) {
            b.className = 'psbb__slot psbb__slot--full';
            b.setAttribute('aria-label', 'Editar pantalón ' + (i + 1));
            if (img.getAttribute('src') !== sl.image) img.src = sl.image;   // sin re-pedir la misma foto
            img.alt = sl.color;
            nom.textContent = sl.color;
            met.textContent = sl.size + ' / ' + sl.inseam;
          } else {
            b.className = 'psbb__slot psbb__slot--empty';
            b.setAttribute('aria-label', 'Elegir pantalón ' + (i + 1));
            img.removeAttribute('src');
            nom.textContent = '';
            met.textContent = '';
          }
        }
        pack.precios();
      };

      pack.precios = function(){
        var unit    = unitCents(Number(tier.pct) || 0);
        var total   = unit * pack.size;
        var compare = D.basePrice * pack.size;
        nTotal.textContent   = money(total);
        nCompare.textContent = money(compare);
        nSave.textContent    = 'AHORRAS ' + money(compare - total);
        nUnit.textContent    = money(unit) + D.unitSufijo;

        var llenos = pack.llenos();
        nCount.textContent = llenos + ' / ' + pack.size;
        pack.cta.disabled = llenos < pack.size;
      };

      pack.cta.addEventListener('click', function(){
        if (pack.llenos() < pack.size) return;
        /* Se agrupa por variante: dos pantalones idénticos van como UNA línea con
           quantity 2, nunca como dos líneas con el mismo id. Repetir un variant_id
           dentro de items[] rompe el evento de add-to-cart. */
        var conteo = {}, orden = [];
        for (var i = 0; i < pack.size; i++) {
          var id = seleccion[i].variantId;
          if (!conteo[id]) { conteo[id] = 0; orden.push(id); }
          conteo[id]++;
        }
        var items = orden.map(function(id){
          var it = { id: Number(id), quantity: conteo[id] };
          if (D.tagItems) it.properties = { _pack: pack.size + '-Pack' };
          return it;
        });
        alCarrito(items, pack.cta);
      });

      packs.push(pack);
      pack.render();
      return pack;
    }

    /* ── Panel de 1 pant ────────────────────────────────────────────────── */
    /* Mismo orden y mismos estilos que la PDP: color, talla (+ guía), caja de
       cruce al otro producto, largo (+ guía), carrito y notas. */
    function nuevoUno(tier, el){
      var uno = { tier: tier, el: el, tipo: 'uno', sel: {color:null, size:null, inseam:null} };

      var caja = document.createElement('div');
      caja.className = 'psbb psbb-uno';
      caja.innerHTML = '' +
        '<div class="psbb-uno__field">' +
          '<div class="psbb-uno__labelRow"><span class="psbb-uno__names">' +
            '<span class="psbb-uno__label">' + esc(D.labelColor || 'COLOR') + '</span>' +
            '<span class="psbb-uno__value" data-uno-colorname></span></span></div>' +
          '<div class="psbb-uno__swatches" data-uno-swatches></div>' +
        '</div>' +
        '<div class="psbb-uno__field">' +
          '<div class="psbb-uno__labelRow"><span class="psbb-uno__names">' +
            '<span class="psbb-uno__label">' + esc(D.labelTalla || 'TALLA') + '</span>' +
            '<span class="psbb-uno__value" data-uno-sizename></span></span>' +
            '<button type="button" class="psbb-uno__guide" data-guide="talla">' + esc(D.textoGuia || 'Guía de tallas') + '</button>' +
          '</div>' +
          '<div class="psbb-uno__opts" data-uno-sizes></div>' +
        '</div>' +
        cajaCruce('psbb-uno__cross', 'psbb-uno__crossText', 'psbb-uno__crossPill') +
        '<div class="psbb-uno__field">' +
          '<div class="psbb-uno__labelRow"><span class="psbb-uno__names">' +
            '<span class="psbb-uno__label">' + esc(D.labelLargo || 'LARGO DE PIERNA') + '</span>' +
            '<span class="psbb-uno__value" data-uno-inseamname></span></span>' +
            '<button type="button" class="psbb-uno__guide" data-guide="largo">' + esc(D.textoGuia || 'Guía de tallas') + '</button>' +
          '</div>' +
          '<div class="psbb-uno__opts" data-uno-inseams></div>' +
        '</div>' +
        '<div class="psbb-uno__foot">' +
          '<button type="button" class="psbb__cta" data-uno-cta>' + esc(D.ctaUno || 'Agregar al carrito') + '</button>' +
          markupPie() +
        '</div>';
      el.appendChild(caja);

      var cta = caja.querySelector('[data-uno-cta]');

      caja.addEventListener('click', function(e){
        var g = e.target.closest('[data-guide]');
        if (g) { e.preventDefault(); abrirGuia(g.getAttribute('data-guide')); }
      });

      // swatches
      var sw = caja.querySelector('[data-uno-swatches]');
      D.colors.forEach(function(c){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'psbb-uno__swatch';
        b.style.background = c.hex; b.title = c.name; b.setAttribute('aria-label', c.name);
        b.setAttribute('aria-pressed','false');
        b.addEventListener('click', function(){ uno.sel.color = c.name; uno.sync(true); });
        sw.appendChild(b);
      });
      opciones(caja.querySelector('[data-uno-sizes]'),   D.sizes,   'size');
      opciones(caja.querySelector('[data-uno-inseams]'), D.inseams, 'inseam');

      function opciones(host, valores, key){
        valores.forEach(function(v){
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'psbb-uno__opt'; b.textContent = v;
          b.setAttribute('aria-pressed','false');
          b.addEventListener('click', function(){ uno.sel[key] = v; uno.sync(true); });
          host.appendChild(b);
        });
      }

      /* avisar=true => además empuja la variante a Instant (galería, precio, etc.) */
      uno.sync = function(avisar){
        var color = colorPorNombre(uno.sel.color);
        uno.sel.color = color.name;

        caja.querySelector('[data-uno-colorname]').textContent  = color.name;
        caja.querySelector('[data-uno-sizename]').textContent   = uno.sel.size   || '';
        caja.querySelector('[data-uno-inseamname]').textContent = uno.sel.inseam || '';

        [].forEach.call(caja.querySelectorAll('[data-uno-swatches] .psbb-uno__swatch'), function(b, i){
          b.setAttribute('aria-pressed', String(D.colors[i].name === uno.sel.color));
        });
        // Tachón: la talla se tacha si ningún largo de ese color tiene stock;
        // el largo, según la combinación color + talla ya elegida.
        [].forEach.call(caja.querySelectorAll('[data-uno-sizes] .psbb-uno__opt'), function(b){
          b.setAttribute('aria-pressed', String(b.textContent === uno.sel.size));
          b.classList.toggle('psbb-uno__opt--agotado', !tallaConStock(color.name, b.textContent));
        });
        [].forEach.call(caja.querySelectorAll('[data-uno-inseams] .psbb-uno__opt'), function(b){
          b.setAttribute('aria-pressed', String(b.textContent === uno.sel.inseam));
          b.classList.toggle('psbb-uno__opt--agotado',
            !!uno.sel.size && !hayStock(color.name, uno.sel.size, b.textContent));
        });

        var listo = !!(uno.sel.color && uno.sel.size && uno.sel.inseam);
        var disponible = listo && hayStock(uno.sel.color, uno.sel.size, uno.sel.inseam);
        cta.disabled = !disponible;
        cta.textContent = (listo && !disponible) ? (D.textoAgotado || 'Agotado') : (D.ctaUno || 'Agregar al carrito');

        if (avisar) {
          ultima = { color: uno.sel.color, size: uno.sel.size, inseam: uno.sel.inseam };
          avisarAInstant(uno.sel);
        }
      };

      uno.alMostrar = function(){
        // Hereda lo último elegido en cualquier panel, validado contra este producto.
        if (ultima) {
          if (D.colors.some(function(c){ return c.name === ultima.color; })) uno.sel.color = ultima.color;
          if (D.sizes.indexOf(ultima.size) > -1)     uno.sel.size   = ultima.size;
          if (D.inseams.indexOf(ultima.inseam) > -1) uno.sel.inseam = ultima.inseam;
        }
        uno.sync(true);
      };

      cta.addEventListener('click', function(){
        var id = D.variants[uno.sel.color + '|' + uno.sel.size + '|' + uno.sel.inseam];
        if (!id) return;
        var it = { id: Number(id), quantity: 1 };
        if (D.tagItems) it.properties = { _pack: '1-Pack' };
        alCarrito([it], cta);
      });

      // Preselección como la PDP: primer color, primera talla y primer largo.
      uno.sel.color  = D.colors[0].name;
      uno.sel.size   = D.unoPreselect === false ? null : D.sizes[0];
      uno.sel.inseam = D.unoPreselect === false ? null : D.inseams[0];
      uno.sync(false);

      return uno;
    }

    /* ── Sincronía con Instant ──────────────────────────────────────────── */
    /* Instant guarda la variante elegida en inputs dentro de su <form>, y al
       disparar 'change' re-renderiza galería, precio y botón nativo. Replicamos
       exactamente eso (mismo camino que su variant picker) para que el tab de 1
       pant mueva la galería aunque el picker nativo ya no esté en la página. */
    var formInstant;
    function formDeInstant(){
      if (formInstant !== undefined) return formInstant;
      var todos = [].slice.call(document.querySelectorAll('[data-instant-form-product-url]'));
      formInstant = null;
      for (var i = 0; i < todos.length; i++) {
        if (String(todos[i].getAttribute('data-instant-form-product-id')) === String(D.productId)) {
          formInstant = todos[i]; break;
        }
      }
      if (!formInstant && todos.length === 1) formInstant = todos[0];
      return formInstant;
    }

    /* El prefijo de los inputs de Instant es el id del form sin la "i" inicial.
       Se busca clase por clase: un match suelto sobre el className completo podría
       morder "instant-…" y devolver basura. */
    function prefijoForm(form){
      var clases = [].slice.call(form.classList || []);
      if (form.id) clases.unshift(form.id);
      for (var i = 0; i < clases.length; i++) {
        if (/^i[A-Za-z0-9]{10,}$/.test(clases[i])) return clases[i].slice(1);
      }
      return null;
    }

    function avisarAInstant(sel){
      if (D.syncInstant === false) return;
      var form = formDeInstant();
      if (!form) return;
      var pref = prefijoForm(form);
      if (!pref) return;
      var nombres = D.optionNames || {};
      var pares = [[nombres.color, sel.color], [nombres.size, sel.size], [nombres.inseam, sel.inseam]];
      var algo = false;
      pares.forEach(function(par){
        if (!par[0] || !par[1]) return;
        // Instant guarda el nombre de la opción codificado ("Largo%20pierna").
        var nombre = encodeURIComponent(par[0]);
        var ins = form.querySelectorAll('input[name^="' + pref + '"][name$="' + nombre + '"]');
        if (ins.length === 1) { ins[0].value = par[1]; }
        else if (ins.length > 1) {
          [].forEach.call(ins, function(inp){ inp.checked = (inp.value === par[1]); });
        } else {
          var h = document.createElement('input');
          h.type = 'hidden'; h.name = pref + '__' + nombre; h.value = par[1];
          form.appendChild(h);
        }
        algo = true;
      });
      if (algo) {
        try { form.dispatchEvent(new Event('change', {bubbles:true, cancelable:true})); } catch (e) {}
      }
    }

    /* ── Modal de selección (paquetes) ──────────────────────────────────── */
    var modal = null, sel = {color:null, size:null, inseam:null}, packActivo = null, slotActivo = 0;
    var hdoc = document;   // documento donde vive el modal

    // Si el bloque corre dentro de un iframe (editor de Instant, previews, algunos temas),
    // position:fixed queda atrapado en el iframe. Si el padre es del mismo origen nos
    // montamos ahí para cubrir la pantalla completa de verdad.
    function pickHostDoc(){
      try {
        if (window.self !== window.top && window.top.document && window.top.document.body) {
          void window.top.document.body.tagName;   // lanza si es cross-origin
          return window.top.document;
        }
      } catch (e) {
        console.warn('[psbb] Embed dentro de un iframe de otro origen: el popup queda limitado al iframe.');
      }
      return document;
    }

    // Caja que cruza al otro producto. En la PDP normal apunta al XL y viceversa;
    // con el texto vacío no se pinta.
    function cajaCruce(clsCaja, clsTexto, clsPill){
      if (!D.cruceTexto) return '';
      return '<div class="' + clsCaja + '">' +
               '<span class="' + clsTexto + '">' + esc(D.cruceTexto) + '</span>' +
               '<a class="' + clsPill + '" href="' + esc(D.cruceUrl) + '">' +
                 esc(D.cruceBoton) + ' &rarr;</a>' +
             '</div>';
    }

    function buildModal(){
      hdoc = pickHostDoc();
      // si nos mudamos de documento hay que llevarnos los estilos
      if (hdoc !== document && !hdoc.getElementById('psbb-modal-css')) {
        var el = null;
        var inline = document.querySelector('[data-psbb-css]');
        var link   = document.querySelector('link[href*="psbb.css"]');
        if (inline) { el = hdoc.createElement('style'); el.textContent = inline.textContent; }
        else if (link) { el = hdoc.createElement('link'); el.rel = 'stylesheet'; el.href = link.href; }
        if (el) { el.id = 'psbb-modal-css'; hdoc.head.appendChild(el); }
      }
      modal = hdoc.createElement('dialog');
      modal.className = 'psbb-modal';
      modal.innerHTML =
        '<div class="psbb-modal__backdrop" data-close></div>' +
        '<div class="psbb-modal__sheet" role="dialog" aria-modal="true" aria-label="Elegir pantalón">' +
          '<button type="button" class="psbb-modal__close" data-close aria-label="Cerrar">&times;</button>' +
          '<div class="psbb-modal__slider">' +
            '<button type="button" class="psbb-modal__arrow psbb-modal__arrow--prev" data-prev aria-label="Anterior">&#8249;</button>' +
            '<div class="psbb-modal__track" data-track></div>' +
            '<button type="button" class="psbb-modal__arrow psbb-modal__arrow--next" data-next aria-label="Siguiente">&#8250;</button>' +
          '</div>' +
          '<div class="psbb-modal__field">' +
            '<div class="psbb-modal__labelRow"><span class="psbb-modal__label">' + esc(D.labelColor || 'COLOR') + '<em data-colorname></em></span></div>' +
            '<div class="psbb-modal__swatches" data-swatches></div>' +
          '</div>' +
          '<div class="psbb-modal__field">' +
            '<div class="psbb-modal__labelRow"><span class="psbb-modal__label">' + esc(D.labelTalla || 'TALLA') + '<em data-sizename></em></span>' +
              '<button type="button" class="psbb-modal__guide" data-guide="talla">' + esc(D.textoGuia || 'Guía de tallas') + '</button></div>' +
            '<div class="psbb-modal__opts" data-sizes></div>' +
          '</div>' +
          cajaCruce('psbb-modal__xl', 'psbb-modal__xlText', 'psbb-modal__xlPill') +
          '<div class="psbb-modal__field">' +
            '<div class="psbb-modal__labelRow"><span class="psbb-modal__label">' + esc(D.labelLargo || 'LARGO PIERNA') + '<em data-inseamname></em></span>' +
              '<button type="button" class="psbb-modal__guide" data-guide="largo">' + esc(D.textoGuia || 'Guía de tallas') + '</button></div>' +
            '<div class="psbb-modal__opts psbb-modal__opts--inseam" data-inseams></div>' +
          '</div>' +
          '<button type="button" class="psbb-modal__add" data-add disabled>Agregar al paquete</button>' +
        '</div>';
      hdoc.body.appendChild(modal);

      modal.addEventListener('click', function(e){
        var g = e.target.closest('[data-guide]');
        if (g) { e.preventDefault(); abrirGuia(g.getAttribute('data-guide')); return; }
        if (e.target.closest('[data-close]')) closeModal();
      });
      // showModal() ya cierra con Esc por su cuenta; sincronizamos el scroll al cerrar
      modal.addEventListener('close', releaseScroll);
      if (typeof modal.showModal !== 'function') {
        hdoc.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal(); });
      }

      var track = modal.querySelector('[data-track]');
      var step = function(){ var im = track.querySelector('img'); return im ? im.offsetWidth + 8 : 240; };
      modal.querySelector('[data-prev]').addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      modal.querySelector('[data-next]').addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });

      modal.querySelector('[data-add]').addEventListener('click', commit);

      // swatches (fijos)
      var sw = modal.querySelector('[data-swatches]');
      D.colors.forEach(function(c){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'psbb-modal__swatch';
        b.style.background = c.hex; b.title = c.name; b.setAttribute('aria-label', c.name);
        b.setAttribute('aria-pressed','false');
        b.addEventListener('click', function(){ sel.color = c.name; syncModal(); });
        sw.appendChild(b);
      });
      buildOpts(modal.querySelector('[data-sizes]'),   D.sizes,   'size');
      buildOpts(modal.querySelector('[data-inseams]'), D.inseams, 'inseam');
    }

    function buildOpts(host, values, key){
      values.forEach(function(v){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'psbb-modal__opt'; b.textContent = v;
        b.setAttribute('aria-pressed','false');
        b.addEventListener('click', function(){ sel[key] = v; syncModal(); });
        host.appendChild(b);
      });
    }

    function syncModal(){
      var color = colorPorNombre(sel.color);

      // galería del color
      var track = modal.querySelector('[data-track]');
      if (track.dataset.color !== color.name) {
        track.dataset.color = color.name;
        track.innerHTML = '';
        (color.images || []).forEach(function(src){
          var im = document.createElement('img');
          im.src = src; im.alt = color.name; im.loading = 'lazy';
          track.appendChild(im);
        });
        track.scrollLeft = 0;
      }

      modal.querySelector('[data-colorname]').textContent  = ' ' + color.name;
      modal.querySelector('[data-sizename]').textContent   = sel.size   ? ' ' + sel.size   : '';
      modal.querySelector('[data-inseamname]').textContent = sel.inseam ? ' ' + sel.inseam : '';

      [].forEach.call(modal.querySelectorAll('[data-swatches] .psbb-modal__swatch'), function(b, i){
        b.setAttribute('aria-pressed', String(D.colors[i].name === sel.color));
      });
      // Tachón en lo agotado. Talla: sólo si ningún largo de ese color tiene stock.
      // Largo: según la combinación color + talla ya elegida.
      [].forEach.call(modal.querySelectorAll('[data-sizes] .psbb-modal__opt'), function(b){
        b.setAttribute('aria-pressed', String(b.textContent === sel.size));
        b.classList.toggle('psbb-modal__opt--agotado', !tallaConStock(color.name, b.textContent));
      });
      [].forEach.call(modal.querySelectorAll('[data-inseams] .psbb-modal__opt'), function(b){
        b.setAttribute('aria-pressed', String(b.textContent === sel.inseam));
        b.classList.toggle('psbb-modal__opt--agotado',
          !!sel.size && !hayStock(color.name, sel.size, b.textContent));
      });

      modal.querySelector('[data-add]').disabled =
        !(sel.color && sel.size && sel.inseam && hayStock(sel.color, sel.size, sel.inseam));
    }

    function openModal(pack, index, conservarSel){
      if (!modal) buildModal();
      packActivo = pack;
      slotActivo = index;
      var cur = seleccion[index];
      if (!conservarSel) {
        if (cur) {
          sel = {color:cur.color, size:cur.size, inseam:cur.inseam};
        } else {
          // se valida contra el producto actual: el JogPant y el XL no comparten tallas
          var rc = ultima && D.colors.some(function(c){ return c.name === ultima.color; })
                   ? ultima.color : null;
          var rs = ultima && D.sizes.indexOf(ultima.size) > -1 ? ultima.size : null;
          var rl = ultima && D.inseams.indexOf(ultima.inseam) > -1 ? ultima.inseam : null;
          sel = {
            color:  rc || D.colors[0].name,
            size:   rs || (D.preselect ? D.sizes[0]   : null),
            inseam: rl || (D.preselect ? D.inseams[0] : null)
          };
        }
      }
      modal.querySelector('[data-add]').textContent = cur ? 'Actualizar pantalón' : 'Agregar al paquete';
      syncModal();
      if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); }
      else { modal.setAttribute('open',''); }
      hdoc.documentElement.style.overflow = 'hidden';
    }

    function releaseScroll(){ hdoc.documentElement.style.overflow = ''; }

    function closeModal(){
      if (!modal) return;
      if (typeof modal.close === 'function' && modal.open) modal.close();  // dispara 'close'
      else { modal.removeAttribute('open'); releaseScroll(); }
    }

    function commit(){
      var color = colorPorNombre(sel.color);
      var id = D.variants[sel.color + '|' + sel.size + '|' + sel.inseam];
      if (!id) { alert('Esa combinación no está disponible.'); return; }
      seleccion[slotActivo] = {
        color: sel.color, size: sel.size, inseam: sel.inseam,
        variantId: id, image: (color.images && color.images[0]) || ''
      };
      // se recuerda para el siguiente hueco vacío y para el tab de 1 pant
      ultima = { color: sel.color, size: sel.size, inseam: sel.inseam };
      closeModal();
      // repinta todos: el cambio vale para cualquier tier que muestre ese hueco
      packs.forEach(function(p){ p.render(); });
    }

    /* ── Guía de tallas ─────────────────────────────────────────────────── */
    /* El overlay de Instant tiene su CSS scopeado a su contenedor: moverlo o clonarlo
       dentro de nuestro <dialog> lo deja sin estilos. Y como el <dialog> vive en el top
       layer, la guía (z-index 1000) queda tapada e inerte por debajo.
       Solución: cerramos nuestro modal para soltar el top layer, dejamos que la guía se
       abra en su sitio con sus estilos intactos, y la reabrimos en cuanto se cierra. La
       selección no se pierde porque `sel` vive fuera del modal. */
    var guiaObs = null;

    /* Localiza el overlay de la guía en tres pasos, de más a menos específico:
         1. el id configurado (cada página de Instant tiene el suyo: sandbox != producción);
         2. un botón "Guía de tallas" nativo que siga en la página, y de ahí su overlay;
         3. el texto del propio overlay — el de talla habla de CINTURA y el de largo de
            ALTURA, y eso no cambia entre páginas.
       El paso 3 es el que nos deja quitar los tabs de Instant sin quedarnos sin guía.
       Busca en nuestro documento y en el del padre, por si corremos dentro de un iframe. */
    function resolverGuia(cual){
      var docs = [document];
      if (hdoc && hdoc !== document) docs.push(hdoc);
      var id = cual === 'largo' ? D.overlayLargo : D.overlayTalla;
      var patron = cual === 'largo' ? /altura/i : /cintura/i;
      var i, d, trg, ov, aid;

      if (id) {
        for (i = 0; i < docs.length; i++) {
          d = docs[i];
          ov = d.querySelector('#i' + id) || d.querySelector('.i' + id);
          if (ov) {
            trg = d.querySelector('[data-instant-action-id="' + id + '"][data-instant-action-type="open-overlay"]');
            return { trg: trg || null, ov: ov };
          }
        }
      }
      for (i = 0; i < docs.length; i++) {
        d = docs[i];
        var lista = [].slice.call(d.querySelectorAll('[data-instant-action-type="open-overlay"]'))
          .filter(function(e){ return /gu[ií]a\s*de\s*tallas/i.test(e.textContent || ''); });
        for (var j = 0; j < lista.length; j++) {
          aid = lista[j].getAttribute('data-instant-action-id');
          ov  = aid ? (d.querySelector('#i' + aid) || d.querySelector('.i' + aid)) : null;
          if (ov && patron.test(ov.textContent || '')) return { trg: lista[j], ov: ov };
        }
      }
      for (i = 0; i < docs.length; i++) {
        d = docs[i];
        var overlays = [].slice.call(d.querySelectorAll('[data-instant-type="overlay"]'))
          .filter(function(e){ return patron.test(e.textContent || ''); });
        if (overlays.length) return { trg: null, ov: overlays[0] };
      }
      return null;
    }

    /* Abre el overlay sin pasar por un botón nativo. Instant enlaza sus listeners de
       click elemento por elemento al arrancar, así que un botón nuestro nunca los
       tendría; en cambio el overlay ya quedó registrado (cierra solo al tocar fuera).
       Esto es lo mismo que hace Instant al abrirlo: marcar data-state y bloquear el
       scroll del body guardando el valor anterior en la variable que él usa. */
    function abrirOverlayDirecto(ov){
      var doc = ov.ownerDocument || document;
      var win = doc.defaultView || window;
      if (ov.getAttribute('data-instant-overlay-pointer-events') === 'AUTO' &&
          typeof win.__instantOverlayBodyOverflow === 'undefined') {
        win.__instantOverlayBodyOverflow = doc.body.style.overflow;
        doc.body.style.overflow = 'hidden';
      }
      ov.setAttribute('data-state','open');
    }

    function abrirGuia(cual){
      var g = resolverGuia(cual);
      if (!g) {
        console.warn('[psbb] No encontré el overlay de "Guía de tallas" en esta página. ' +
                     'Revisa ps_overlay_talla / ps_overlay_largo.');
        if (D.guideUrl) window.open(D.guideUrl, '_blank', 'noopener');
        return;
      }
      var ov = g.ov, trg = g.trg;
      var abrir = function(){ if (trg) trg.click(); else abrirOverlayDirecto(ov); };

      // Desde el panel de 1 pant no hay <dialog> de por medio: se abre y ya.
      if (!modal || !modal.open) { abrir(); return; }

      var pack = packActivo, slot = slotActivo;
      closeModal();
      setTimeout(function(){
        abrir();
        if (guiaObs) guiaObs.disconnect();
        // El overlay ya está abierto cuando llegamos aquí, así que hay que leer el
        // estado, no esperar a verlo cambiar.
        var vioAbierto = ov.getAttribute('data-state') === 'open';
        guiaObs = new MutationObserver(function(){
          if (ov.getAttribute('data-state') === 'open') { vioAbierto = true; return; }
          if (!vioAbierto) return;
          guiaObs.disconnect(); guiaObs = null;
          openModal(pack, slot, true);         // true = conservar lo ya elegido
        });
        guiaObs.observe(ov, {attributes:true, attributeFilter:['data-state']});
      }, 60);
    }

    /* ── Add to cart ────────────────────────────────────────────────────── */
    function alCarrito(items, boton){
      var textoCta = boton.textContent;
      boton.setAttribute('aria-busy','true');
      boton.disabled = true;
      enviarEnLotes(items)
      .then(function(){
        // el mismo evento que Instant emite tras añadir, por si algo lo escucha
        try { document.dispatchEvent(new CustomEvent('instant:add-to-cart',
                { bubbles: false, detail: { useInstantCart: true } })); } catch (e) {}
        return D.openDrawer ? openInstantCart() : false;
      })
      .then(function(abrio){
        boton.textContent = textoCta;
        if (!abrio) { window.location.href = D.cartUrl; return; }   // sin drawer: al carrito
        boton.removeAttribute('aria-busy');
        boton.disabled = false;
      })
      .catch(function(err){
        boton.textContent = textoCta;
        boton.removeAttribute('aria-busy');
        boton.disabled = false;
        alert('No se pudo agregar al carrito: ' + err.message);
      });
    }

    /* La petición al carrito, con la cabecera x-instant-client: medido en producción,
       con ella los packs se trackean y sin ella no se trackea ninguno. */
    /* El botón nativo de Instant manda dos cosas que hay que replicar para que su evento
       de add-to-cart se comporte igual: la lista de secciones a re-renderizar y la propiedad
       _instant-ref en cada línea. Ambas se derivan de la propia página. */
    function seccionesDeCarrito(){
      var d = document, ids = {};
      d.querySelectorAll('[data-instant-layout="CART"][data-section-id]').forEach(function(e){
        ids[e.getAttribute('data-section-id')] = 1;
      });
      d.querySelectorAll('[data-instant-dynamic-content-source^="CART"]').forEach(function(e){
        var sec = e.closest('[data-section-id]');
        if (sec) ids[sec.getAttribute('data-section-id')] = 1;
      });
      return Object.keys(ids).join(',');
    }

    function instantRef(){
      var e = document.querySelector('[data-instant-layout="PRODUCT_TEMPLATE"][data-instant-id]')
           || document.querySelector('[data-instant-layout][data-instant-id]');
      return e ? e.getAttribute('data-instant-layout') + ':' + e.getAttribute('data-instant-id') : null;
    }

    function postAdd(lote, intento){
      intento = intento || 0;
      var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      return fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-instant-client': 'shopify-core' },
        body: JSON.stringify(cuerpoAdd(lote))
      }).then(function(r){
        // Shopify limita la frecuencia del Ajax Cart API: mandando un pantalón por
        // petición se puede topar un 429. Reintentamos con espera creciente — si esto
        // fallara en silencio, el cliente pagaría el pack completo y recibiría menos.
        if (r.status === 429 && intento < 5) {
          return new Promise(function(res){ setTimeout(res, 700 * (intento + 1)); })
            .then(function(){ return postAdd(lote, intento + 1); });
        }
        if (!r.ok) {
          return r.text().then(function(txt){
            var msg = 'Error ' + r.status;
            try { var j = JSON.parse(txt); msg = j.description || j.message || msg; } catch (e) {}
            throw new Error(msg);
          });
        }
        return r.json();
      });
    }

    function cuerpoAdd(lote){
      var ref = instantRef();
      var secciones = seccionesDeCarrito();
      var items = lote.map(function(it){
        var props = {};
        if (it.properties) for (var k in it.properties) props[k] = it.properties[k];
        if (ref) props['_instant-ref'] = ref;
        var o = { id: it.id, quantity: it.quantity };
        for (var p in props) { o.properties = props; break; }
        return o;
      });
      var cuerpo = { items: items };
      if (secciones) cuerpo.sections = secciones;
      return cuerpo;
    }

    /* Los paquetes grandes pueden ir en lotes. Cinco variantes del mismo producto
       disparan cinco eventos casi idénticos en menos de un segundo, y ese es el patrón
       que se pierde. Con loteMax=0 todo va en una sola llamada, que es lo recomendado. */
    function enviarEnLotes(items){
      var max = D.loteMax || 0;
      if (!max || items.length <= max) return postAdd(items);
      var lotes = [];
      for (var i = 0; i < items.length; i += max) lotes.push(items.slice(i, i + max));
      return lotes.reduce(function(cadena, lote, idx){
        return cadena.then(function(){
          if (!idx) return postAdd(lote);
          return new Promise(function(res){ setTimeout(res, D.loteEspera || 700); })
                   .then(function(){ return postAdd(lote); });
        });
      }, Promise.resolve());
    }

    /* Abre el cart drawer de Instant.
       Refresca primero (Instant.api.updateCart) para que el drawer muestre lo recién
       agregado, y luego dispara un [data-instant-action-type="trigger-instant-cart"] que
       ya existe en la página: es el mismo camino que usa el ícono del carrito del header,
       así que no dependemos de nombres internos minificados.
       Devuelve false si no encuentra drawer, para caer al redirect de siempre. */
    function openInstantCart(){
      var d = hdoc || document;
      var w = d.defaultView || window;
      var api = null;
      try { api = w.Instant && w.Instant.api; } catch (e) {}

      // Mandamos la cabecera x-instant-client, así que Instant da el POST por suyo y NO
      // refresca sus secciones. El refresco lo tenemos que hacer nosotros y ESPERARLO
      // antes de abrir: si no, el drawer se abre con el HTML anterior y se ve vacío.
      var refresco = Promise.resolve();
      if (api && typeof api.updateCart === 'function') {
        try { refresco = Promise.resolve(api.updateCart()); } catch (e) {}
      }
      return refresco.catch(function(){}).then(function(){
        if (api && typeof api.toggleCart === 'function') {
          try { api.toggleCart(true); return true; } catch (e) {}
        }
        var trg = d.querySelector('[data-instant-action-type="trigger-instant-cart"]');
        if (trg) { trg.click(); return true; }
        return false;
      });
    }
  }

  function initAll(){
    var nodos = document.querySelectorAll('[data-psbb-root], [data-psbb]');
    for (var i = 0; i < nodos.length; i++) initApp(nodos[i]);
  }

  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  // los tabs de Instant pueden pintar sus paneles tarde: reintentamos un rato
  var n = 0;
  var t = setInterval(function(){ initAll(); if (++n > 40) clearInterval(t); }, 400);
})();
